export default __webpack_public_path__ + "static/media/2.68e95988.png";